import heroImage from "../assets/illustration.svg";
import iconBulb from '../assets/iconBulb.png';
import iconPuzzle from '../assets/iconPuzzle.png';
import iconRocket from '../assets/iconRocket.png';
import skilledIcon from '../assets/skilledIcon.png';
import { Helmet } from "react-helmet";

import CountUp from "react-countup";
import { toast, ToastContainer } from "react-toastify";

import { useState, useEffect,useRef } from "react";
import image1 from "../assets/image1.png"; 
import image2 from "../assets/image2.png"; 
import groupedImage from "../assets/developerGroup.webp";
import codeIcon from '../assets/code-icon.png';
import paintIcon from '../assets/paint-icon.png';
import { motion } from 'framer-motion';
import phoneIcon from '../assets/phone-icon.png';
import mailIcon from '../assets/mail-icon.svg';
import arrowRight from '../assets/arrow-icon.png';
import personImage from '../assets/person.png';

import aiBot from '../assets/ai-bot.png'; 
import { useNavigate } from 'react-router-dom'; 
import ReactIcon from "../assets/react.svg";
import NextIcon from "../assets/nextjs.svg";
import AngularIcon from "../assets/angular.svg";
import VueIcon from "../assets/vue.svg";
import TranscriptIcon from "../assets/transcript.svg";
import JavaScriptIcon from "../assets/javascript.svg";
import BootstrapIcon from "../assets/bootstrap.svg";
import HTML5Icon from "../assets/html5.svg";
import FlutterIcon from "../assets/flutter.svg";
import CSS3Icon from "../assets/css3.svg";


import NodeIcon from "../assets/nodejs.svg";
import PythonIcon from "../assets/python.svg";
import JavaIcon from "../assets/java.svg";
import DotNetIcon from "../assets/dotnet.svg";
import PHPIcon from "../assets/php.svg";

import MySQLIcon from "../assets/mysql.svg";
import PostgreSQLIcon from "../assets/postgresql.svg";
import SQLServerIcon from "../assets/sqlserver.svg";
import MongoDBIcon from "../assets/mongodb.svg";
import OracleIcon from "../assets/oracle.svg";
import SQLiteIcon from "../assets/sqllite.svg";
import MSAccessIcon from "../assets/msaccess.svg";
import FigmaIcon from "../assets/figma.svg";
import IOS from "../assets/ios.svg";
import Android from "../assets/android.svg";
import Kotlin from "../assets/kotlin.svg";
import Lonic from "../assets/lonic.svg";
import Xamarin from "../assets/xamarin.svg";
import Swift from "../assets/swift.svg";
import Gemini from "../assets/gemini.svg";
import OpenAI from "../assets/openai.svg";
import AzureAI from "../assets/azureai.svg";
import LamaAI from "../assets/lama.svg";


import XDIcon from "../assets/xd.svg";
import PhotoshopIcon from "../assets/photoshop.svg";
import IllustratorIcon from "../assets/illustrator.svg";
import AfterEffectsIcon from "../assets/aftereffects.svg";
import AWSIcon from "../assets/aws.svg";
import AzureIcon from "../assets/azure.svg";
import GCPIcon from "../assets/gcp.svg";
import aiServices from "../assets/ai-services.png";
import webDevelopment from "../assets/web-development.png";
import integration from "../assets/integration.png";
import mobileApp from "../assets/mobile-app.png";
import customDev from "../assets/custom-dev.png";
import enterpriseApp from "../assets/enterprise-app.png"
import softwareDev from "../assets/software-dev.webp";
import logo1 from "../assets/logo1.png";
import logo2 from "../assets/logo2.png";
import logo3 from "../assets/logo3.png";
import logo4 from "../assets/logo4.png";
import logo5 from "../assets/logo5.png";
import logo6 from "../assets/logo6.png";
import logo7 from "../assets/logo7.png";
import logo8 from "../assets/logo8.png";


import logistics from "../assets/logistics.svg";
import manufacturing from "../assets/manufacturing.svg";
import warehouse from "../assets/warehouse.svg";
import fintech from "../assets/fintech.svg";
import healthtech from "../assets/healthtech.svg";
import edtech from "../assets/edtech.svg";
import ecommerce from "../assets/ecommerce.svg";
import construction from "../assets/construction.svg";
import energy from "../assets/energy.svg";
import {useAnimation } from "framer-motion";
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phonee from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";
import nlen from "../assets/Nlen.svg";
import user from "../assets/user.png";  
import { Link } from 'react-router-dom';















const HeroSection = () => {
  // const animateScroll = async () => {
  //   while (!isStopped) {
  //     if (direction.current === "left") {
  //       await controls.start({
  //         x: "-50%",
  //         transition: { duration: 20, ease: "linear" },
  //       });
  //       direction.current = "right";
  //     } else {
  //       await controls.start({
  //         x: "0%",
  //         transition: { duration: 20, ease: "linear" },
  //       });
  //       direction.current = "left";
  //     }
  //   }
  // };
const controls = useAnimation();
  const [isStopped, setIsStopped] = useState(false);
  const direction = useRef("left");

  useEffect(() => {
    animateScroll();
  }, [isStopped]);

  // ✅ Toggle scroll on image area click
  const handleToggleScroll = () => {
    setIsStopped((prev) => !prev);
  };
  // const controls = useAnimation();
  // const [isStopped, setIsStopped] = useState(false);
  // const direction = useRef("left");
   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
      const [isServicesOpen, setIsServicesOpen] = useState(false);
      const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
      const [isCompanyOpen, setIsCompanyOpen] = useState(false);
    
      const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
      };
    
      const toggleServicesDropdown = () => {
        setIsServicesOpen(!isServicesOpen);
      };
    
      const toggleIndustriesDropdown = () => {
        setIsIndustriesOpen(!isIndustriesOpen);
      };
    
      const toggleCompanyDropdown = () => {
        setIsCompanyOpen(!isCompanyOpen);
      };
  //  const controls = useAnimation();
  // const [isStopped, setIsStopped] = useState(false);
  // const direction = useRef("left");

  const animateScroll = async () => {
    while (!isStopped) {
      if (direction.current === "left") {
        await controls.start({
          x: "-50%",
          transition: { duration: 20, ease: "linear" },
        });
        direction.current = "right";
      } else {
        await controls.start({
          x: "0%",
          transition: { duration: 20, ease: "linear" },
        });
        direction.current = "left";
      }
    }
  };

  useEffect(() => {
    if (!isStopped) animateScroll();
    return () => controls.stop();
  }, [isStopped]);

  const handleCardClick = () => {
    setIsStopped((prev) => !prev); // Toggle scroll on click
  };
  // const [openDropdown, setOpenDropdown] = useState(null);

  // const toggleDropdown = (menu) => {
  //   setOpenDropdown((prev) => (prev === menu ? null : menu));
  // };
  const scrollRef = useRef(null);       // ✅ Define scrollRef
  const directionRef = useRef(null);    // ✅ Define directionRef


  const navigate = useNavigate();
 
  const handleClick = () => {
    navigate("/Contact#contact-section");
  };

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    let animationFrameId;

    const scroll = () => {
      if (!container) return;

      const maxScroll = container.scrollWidth - container.clientWidth;

      container.scrollLeft += directionRef.current * 0.7;

      if (container.scrollLeft >= maxScroll) {
        directionRef.current = -1;
      } else if (container.scrollLeft <= 0) {
        directionRef.current = 1;
      }

      animationFrameId = requestAnimationFrame(scroll);
    };

    animationFrameId = requestAnimationFrame(scroll);

    return () => cancelAnimationFrame(animationFrameId);
  }, []);
  

   useEffect(() => {
    let animationFrameId;
    let scrollAmount = 0;
    let direction = -1;

    const scrollLoop = () => {
      if (scrollRef.current) {
        scrollRef.current.scrollLeft += direction * 0.5;
        scrollAmount += Math.abs(direction * 0.5);

        if (scrollAmount >= scrollRef.current.scrollWidth / 2) {
          scrollRef.current.scrollLeft = 0;
          scrollAmount = 0;
        }
      }
      animationFrameId = requestAnimationFrame(scrollLoop);
    };

    animationFrameId = requestAnimationFrame(scrollLoop);

    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    let animationFrameId;

    const scroll = () => {
      if (!container) return;

      const maxScroll = container.scrollWidth - container.clientWidth;

      container.scrollLeft += directionRef.current * 0.7;

      if (container.scrollLeft >= maxScroll) {
        directionRef.current = -1;
      } else if (container.scrollLeft <= 0) {
        directionRef.current = 1;
      }

      animationFrameId = requestAnimationFrame(scroll);
    };

    animationFrameId = requestAnimationFrame(scroll);

    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  const services = [
  {
    title: "AI Services",
    description: "Intelligent automation and predictive systems to streamline business.",
    image: aiServices,
    link: "/AI-Services",
  },
  {
    title: "Web Development",
    description: "Modern responsive websites tailored to your brand and goals.",
    image: webDevelopment,
    link: "/web-development",
  },
  {
    title: "Third-party Integration",
    description: "Customized integrations to connect tools seamlessly.",
    image: integration,
    link: "/third-party-integration",
  },
  {
    title: "Mobile App Development",
    description: "Engaging mobile apps to grow your audience and operations.",
    image: mobileApp,
    link: "/mobile-app-development",
  },
  {
    title: "Custom Development",
    description: "Tailored digital products built to your exact needs.",
    image: customDev,
    link: "/custom-development",
  },
  {
    title: "Enterprise Application",
    description: "Streamlined enterprise solutions that drive productivity.",
    image: enterpriseApp,
    link: "/enterprise-application",
  },
  {
    title: "Software Development",
    description: "Robust software systems with scalable architectures.",
    image: softwareDev,
    link: "/software-consulting",
  },
];
const [isOpen, setIsOpen] = useState(false);

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };

  const logos = [logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8,];
  

const industries = [
  {
    title: "Logistics",
    description: "AI optimizes routes, cuts costs, and improves real-time tracking for smarter logistics management.",
    bgColor: "bg-[#FEF5F5]",
    icon: logistics,
    link: "/industries/logistics/",
  },
  {
    title: "Manufacturing",
    description: "AI boosts manufacturing with greater efficiency, less downtime, and smarter decisions.",
    bgColor: "bg-[#F9EFFF]",
    icon: manufacturing,
    link: "/industries/manufacture/",
  },
  {
    title: "Warehouse",
    description: "AI is increasingly being used in warehouses to enhance efficiency, reduce costs, and improve overall operations.",
    bgColor: "bg-[#FEFFD5]",
    icon: warehouse,
    link: "/industries/warehouse/",
  },
  {
    title: "FinTech",
    description: "AI-driven insights, fraud detection, and automation streamline FinTech operations and boost efficiency.",
    bgColor: "bg-[#FDFBE8]",
    icon: fintech,
    link: "/industries/financial-services/",
  },
  {
    title: "Health Tech",
    description: "We transform aviation with AI-driven solutions for efficiency, safety, and smarter operations.",
    bgColor: "bg-[#E7FFF7]",
    icon: healthtech,
    link: "/industries/healthcare/",
  },
  {
    title: "EdTech",
    description: "AI personalizes learning, streamlines administrative tasks, and boosts student engagement in EdTech.",
    bgColor: "bg-[#F1F8FF]",
    icon: edtech,
    link: "/industries/education/",
  },
  {
    title: "E-Commerce",
    description: "AI enhances customer experiences, optimizes inventory management, and drives targeted marketing in e-commerce.",
    bgColor: "bg-[#F2F8FF]",
    icon: ecommerce,
    link: "/industries/ecommerce/",
  },
  {
    title: "Construction",
    description: "AI streamlines project management, anticipates risks, and strengthens safety protocols in construction.",
    bgColor: "bg-[#F9F9F9]",
    icon: construction,
    link: "/#",
  },
  {
    title: "Energy",
    description: "AI optimizes energy distribution by predicting demand and adjusting energy supply to reduce waste.",
    bgColor: "bg-[#E9FDFF]",
    icon: energy,
    link: "/industries/energy/",
  },
];


  const categories = {
  Frontend: [
    { name: "React", icon: ReactIcon },
    { name: "Next.js", icon: NextIcon },
    { name: "Angular", icon: AngularIcon },
    { name: "Vue", icon: VueIcon },
    { name: "Transcript", icon: TranscriptIcon },
    { name: "JavaScript", icon: JavaScriptIcon },
    { name: "Bootstrap", icon: BootstrapIcon },
    { name: "HTML 5", icon: HTML5Icon },
    { name: "Flutter", icon: FlutterIcon },
    { name: "CSS 3", icon: CSS3Icon },
  ],
  Backend: [
    { name: "Node.js", icon: NodeIcon },
    { name: "Python", icon: PythonIcon },
    { name: "Java", icon: JavaIcon },
    { name: "Dot Net", icon: DotNetIcon },
    { name: "PHP", icon: PHPIcon },
  ],
  Database: [
    { name: "MySQL", icon: MySQLIcon },
    { name: "PostgreSQL", icon: PostgreSQLIcon },
    { name: "SQL Server", icon: SQLServerIcon },
    { name: "MongoDB", icon: MongoDBIcon },
    { name: "Oracle", icon: OracleIcon },
    { name: "SQLite", icon: SQLiteIcon },
    { name: "MS Access", icon: MSAccessIcon },
  ],
  Design: [
    { name: "Figma", icon: FigmaIcon },
    { name: "Adobe XD", icon: XDIcon },
    { name: "Photoshop", icon: PhotoshopIcon },
    { name: "Illustrator", icon: IllustratorIcon },
    { name: "After Effects", icon: AfterEffectsIcon },
  ],
  Mobile: [
    { name: "IOS", icon: IOS },
    { name: "Android", icon: Android },
    { name: "React", icon: ReactIcon },
    { name: "Flutter", icon: FlutterIcon },
    { name: "Swift", icon: Swift },
    { name: "Kotlin", icon: Kotlin },
    { name: "Lonic", icon: Lonic },
    { name: "Xamarin", icon: Xamarin },
  ],
  AI: [
    { name: "Gemini", icon: Gemini },
    { name: "OpenAI", icon: OpenAI },
    { name: "AzureAI", icon: AzureAI },
    { name: "LamaAI", icon: LamaAI },
  ],
  Cloud: [
    { name: "AWS", icon: AWSIcon },
    { name: "Azure", icon: AzureIcon },
    { name: "GCP", icon: GCPIcon },
  ],
};
  const [activeTab, setActiveTab] = useState('Frontend');

  const [currentImage, setCurrentImage] = useState(0);
const images = [image1, image2];

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  }, 3000); // Change every 3 seconds
  return () => clearInterval(interval);
}, );



const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };


   const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api.app.mawalog.com/v1.2/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  
  useEffect(() => {
  const canvas = document.getElementById("captchaCanvas");
  if (canvas) {
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.font = "bold 18px Arial";
    ctx.fillStyle = "#00377B";
    ctx.fillText(data, 10, 22);
  }
}, [data]);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };
 
   const canvasRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState(""); // text from API
  const [userCaptcha, setUserCaptcha] = useState("");
 
  /* ------------------------------------------------------------------- API fetch */
  const fetchCaptcha = async () => {
    try {
      const res = await fetch(
        "https://api.app.mawalog.com/v1.2/website"
      );
      const json = await res.json();
      setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
    } catch (err) {
      console.error("Error fetching captcha:", err);
    }
  };
 
  /* -- fetch once on mount ------------------------------------------------------- */
  useEffect(() => {
    fetchCaptcha();
  }, []);
 
  /* -- redraw every time captchaValue changes ------------------------------------ */
 useEffect(() => {
  if (!data) return;
  const canvas = canvasRef.current;
  if (!canvas) return;

  const ctx = canvas.getContext("2d");
  const W = canvas.width;
  const H = canvas.height;

  ctx.clearRect(0, 0, W, H);
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, W, H);

  for (let i = 0; i < 3; i++) {
    ctx.beginPath();
    ctx.moveTo(Math.random() * W, Math.random() * H);
    ctx.bezierCurveTo(
      Math.random() * W,
      Math.random() * H,
      Math.random() * W,
      Math.random() * H,
      Math.random() * W,
      Math.random() * H
    );
    ctx.lineWidth = 1 + Math.random();
    ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
    ctx.stroke();
  }

  ctx.font = "bold 22px Arial";
  ctx.fillStyle = "#0A3A72";
  const chars = data.toString().split("");

  chars.forEach((ch, i) => {
    const angle = (Math.random() - 0.5) * 0.8;
    const x = 8 + i * 14 + (Math.random() * 4 - 2);
    const y = 22 + (Math.random() * 6 - 3);

    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(angle);
    ctx.fillText(ch, 0, 0);
    ctx.restore();
  });

  for (let i = 0; i < 45; i++) {
    ctx.beginPath();
    ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
    ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
    ctx.fill();
  }
}, [data]);

 
  /* -- reload button click ------------------------------------------------------- */
  // const handleReload = () => {
  //   fetch("https://api.app.mawalog.com/v1.2/website")
  //     .then((response) => response.json())
  //     .then((json) => {
  //       setData(json.data.captcha_code);
  //       setSessionid(json.data.session_id);
  //       setToken(json.data.token);
  //     })
  //     .catch((error) => console.error("Error fetching data:", error));
  // };
  //   const handleSubscribe = async () => {
  //   try {
  //     const response = await fetch(
  //       "https://api.app.mawalog.com/v1.2/newsletter",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "X-CSRF-TOKEN": token,
  //         },
  //         body: JSON.stringify({
  //           session_id: sessionid,
  //           captcha: userCaptcha,
  //           email: email,
  //           type: "Mawalog",
  //         }),
  //       }
  //     );
 
  //     const result = await response.json();
  //     console.log("Response:", userCaptcha, " ", data);
  //     setEmail("");
  //    setUserCaptcha("");
  //     toast(result.message);
  //   } catch (error) {
  //     console.error("Error sending request:", error);
  //   }
  // };
  const [name, setName] = useState("");
  // const [email, setEmail] = useState("");
  // const [phone, setPhone] = useState("");
  const [phone, setPhone] = useState("");

  // const [captchaValue, setCaptchaValue] = useState("");
  // const [sessionid, setSessionid] = useState("");
  // const [token, setToken] = useState("");
 
  // const canvasRef = useRef(null);

  // Fetch session ID and token
  useEffect(() => {
    fetch("http://localhost/maw-lumen/sonar-qube/admin_api/book_demo")
      .then((response) => response.json())
      .then((json) => {
        setSessionid(json.data.session_idd);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching token/sessionid:", error));
  }, []);

  // Fetch captcha value
  const fetchCaptchaa = async () => {
    try {
      const res = await fetch("http://localhost/maw-lumen/sonar-qube/admin_api/book_demo");
      const json = await res.json();
      setCaptchaValue(json.data.captcha_code ?? "ERROR");
      setSessionid(json.data.session_id);
      setToken(json.data.token);
    } catch (err) {
      console.error("Error fetching captcha:", err);
    }
  };

  useEffect(() => {
    fetchCaptcha();
  }, []);

  // Draw captcha on canvas
  // useEffect(() => {
  //   if (!captchaValue) return;
  //   const canvas = canvasRef.current;
  //   const ctx = canvas.getContext("2d");
  //   const W = canvas.width;
  //   const H = canvas.height;

  //   ctx.clearRect(0, 0, W, H);
  //   ctx.fillStyle = "#ffffff";
  //   ctx.fillRect(0, 0, W, H);

  //   for (let i = 0; i < 3; i++) {
  //     ctx.beginPath();
  //     ctx.moveTo(Math.random() * W, Math.random() * H);
  //     ctx.bezierCurveTo(
  //       Math.random() * W,
  //       Math.random() * H,
  //       Math.random() * W,
  //       Math.random() * H,
  //       Math.random() * W,
  //       Math.random() * H
  //     );
  //     ctx.lineWidth = 1 + Math.random();
  //     ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
  //     ctx.stroke();
  //   }

  //   ctx.font = "bold 22px Arial";
  //   ctx.fillStyle = "#0A3A72";
  //   captchaValue.split("").forEach((ch, i) => {
  //     const angle = (Math.random() - 0.5) * 0.8;
  //     const x = 8 + i * 14 + (Math.random() * 4 - 2);
  //     const y = 22 + (Math.random() * 6 - 3);
  //     ctx.save();
  //     ctx.translate(x, y);
  //     ctx.rotate(angle);
  //     ctx.fillText(ch, 0, 0);
  //     ctx.restore();
  //   });

  //   for (let i = 0; i < 45; i++) {
  //     ctx.beginPath();
  //     ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
  //     ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
  //     ctx.fill();
  //   }
  // }, [captchaValue]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !email || !phone) {
      setFormError("Please fill all fields.");
      setFormSuccess("");
      return;
    }

    setFormError("");

    try {
      const captchaRes = await fetch("http://localhost/maw-lumen/sonar-qube/admin_api/book_demo");
      const captchaJson = await captchaRes.json();

      const response = await fetch(
        "http://localhost/maw-lumen/sonar-qube/admin_api/book_demo",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": token,
          },
          body: JSON.stringify({
            session_id: captchaJson.data.session_id,
            captcha: captchaJson.data.captcha_code,
            name,
            email,
            phone,
          }),
        }
      );

      const result = await response.json();

      if (response.ok && (result.success || result.status)) {
        setFormSuccess("Message sent successfully!");
        setFormError("");
        setName("");
        setEmail("");
        setPhone("");
        fetchCaptcha();
        

      } else {
        setFormError(result.message || "Validation error.");
        setFormSuccess("");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setFormError("Something went wrong. Try again.");
      setFormSuccess("");
    }
  };

   // Newsletter captcha refs/state (separate)
  const [submail, setSubmail] = useState("");
  const newsletterCanvasRef = useRef(null);
  const [newsCaptcha, setNewsCaptcha] = useState("");
  const [newsletterCaptcha, setNewsletterCaptcha] = useState({ code: "", sessionId: "", token: "" });
  const [newsletterUserCaptcha, setNewsletterUserCaptcha] = useState(""); // <-- new state for newsletter captcha input
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const handleReload = () => {
    fetchNewsletterCaptcha();
  };

  const fetchNewsletterCaptcha = async () => {
    try {
      const response = await fetch("https://api.app.mawalog.com/v1.2/website");
      const json = await response.json();
      if (json?.data) {
        setNewsletterCaptcha({ code: json.data.captcha_code, sessionId: json.data.session_id, token: json.data.token });
      }
    } catch (err) {
      console.error("Error fetching newsletter captcha:", err);
    }
  };

  useEffect(() => {
    // fetch both captchas on mount so both canvases are ready
    fetchNewsletterCaptcha();
  }, []);

  // Draw newsletter captcha whenever it changes
  useEffect(() => {
    if (!newsletterCaptcha?.code) return;
    const canvas = newsletterCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    // noise / curves
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.lineWidth = 1 + Math.random();
      ctx.stroke();
    }

    // draw characters
    const chars = newsletterCaptcha.code.toString().split("");
    ctx.fillStyle = "#0A3A72";
    const fonts = ["Arial", "Verdana", "Georgia", "Courier New", "Times New Roman"];
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 1.2;
      const x = 8 + i * 12 + (Math.random() * 4 - 2);
      const y = 24 + (Math.random() * 6 - 3);
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.font = `bold ${16 + Math.floor(Math.random() * 6)}px ${fonts[Math.floor(Math.random() * fonts.length)]}`;
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    // dots
    for (let i = 0; i < 35; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [newsletterCaptcha]);
  const handleSubscribe = async (e) => {
  e?.preventDefault?.();

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!submail) {
    toast("Please enter an email address");
    return;
  }

  if (!emailRegex.test(submail)) {
    toast("Please enter a valid email address");
    return;
  }

  if (!newsletterUserCaptcha) {
    toast("Please enter the captcha");
    return;
  }

  try {
    const res = await fetch("https://api.app.mawalog.com/v1.2/newsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": newsletterCaptcha.token || "", // use newsletter token
      },
      body: JSON.stringify({
        session_id: newsletterCaptcha.sessionId || "", // use newsletter session id
        captcha: newsletterUserCaptcha, // use newsletter captcha input
        email: submail,
        type: "Mawalog",
      }),
    });

    const result = await res.json();

    // On success clear inputs and reload captcha
    if (res.ok) {
      setSubmail("");
      setNewsletterUserCaptcha("");
      fetchNewsletterCaptcha();
    }

    toast(result.message || "Subscription response received");
  } catch (err) {
    console.error("Newsletter subscribe error:", err);
    toast("Subscription failed. Please try again.");
  }
};

  return (
    
    <>
    <Helmet>
        <title>Lentera Technologies | Expert IT Consulting & AI-Driven Software Solutions</title>
        <meta name="description" content="Delivering AI-powered software, mobile apps, and enterprise solutions since 2015. Hire skilled developers & designers to grow your business efficiently."/>
        <meta name="keywords" content="IT consulting, AI solutions, software development, mobile app development, web development, enterprise applications, custom software, third-party integration, business growth, technology services."/>
      </Helmet>
  
    
   
 


      <section className="font-poppins bg-[#f7f8fa] px-4 sm:px-6 md:px-10 lg:px-20 py-14 md:py-20 overflow-hidden relative">
  <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-12">
    {/* LEFT TEXT SECTION */}
    <div className="w-full lg:w-[60%] text-center lg:text-left">
      <p className="text-[#1A9F3F] text-[18px] md:text-[20px] font-medium mb-4 md:mb-5 leading-[28px] md:leading-[30px]">
        Solutions for your business
      </p>
      <h1 className="text-[#191919] text-[32px] sm:text-[40px] md:text-[48px] lg:text-[56px] font-semi leading-tight mb-5">
        IT consulting with<br className="hidden md:block" />
        professionalism & integrity
      </h1>
      <p className="text-[#5B5B5B] text-[15px] sm:text-[16px] md:text-[18px] leading-[26px] md:leading-[30px] mb-8 max-w-xl mx-auto lg:mx-0">
        We manage professionalism in the IT industry by providing top-quality consulting and related services.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
        <Link to="/Contact">
  <button className="bg-[#1A9F3F] text-white px-6 py-3 rounded-md text-[16px] font-semibold">
    Get a Quote
  </button>
</Link>

<Link to="https://www.lentera.in/why-us/">
  <button className="border border-[#1A9F3F] text-[#1A9F3F] px-6 py-3 rounded-md text-[16px] font-semibold">
    Learn more
  </button>
</Link>
      </div>
    </div>

    {/* RIGHT IMAGE + FLOATING ICONS */}
    <div className="w-full lg:w-[40%] relative max-w-[600px] mx-auto lg:mx-0">
      {/* Hero Image */}
      <img
        src={heroImage}
        alt="Team illustration"
        className="w-full h-auto relative z-10 object-contain"
      />

      {/* Floating Icons */}
      <motion.div
        initial={{ y: -8 }}
        animate={{ y: 0 }}
        transition={{ repeat: Infinity, duration: 2, repeatType: "reverse" }}
        className="absolute top-[-70px] right-3 sm:right-6 md:right-10 bg-white rounded-full p-2 md:p-3 shadow-md z-20"
      >
        <img src={iconBulb} alt="Bulb" className="w-[32px] md:w-[25px] h-[32px] md:h-[25px]" />
      </motion.div>

      <motion.div
        initial={{ y: -10 }}
        animate={{ y: 0 }}
        transition={{ repeat: Infinity, duration: 2.3, repeatType: "reverse" }}
        className="absolute top-[-10px] right-[30px] sm:right-[10px] md:right-[90px] bg-white rounded-full p-2 md:p-3 shadow-md z-20"
      >
        <img src={iconPuzzle} alt="Puzzle" className="w-[36px] md:w-[36px] h-[36px] md:h-[36px]" />
      </motion.div>

      <motion.div
        initial={{ y: -10 }}
        animate={{ y: 0 }}
        transition={{ repeat: Infinity, duration: 2.8, repeatType: "reverse" }}
        className="absolute top-[50px] right-[10px] sm:right-[20px] bg-white rounded-full p-2 md:p-3 shadow-md z-20"
      >
        <img src={iconRocket} alt="Rocket" className="w-[32px] md:w-[25px] h-[32px] md:h-[25px]" />
      </motion.div>

      {/* Floating Badge */}
      <motion.div
        initial={{ x: -10 }}
        animate={{ x: 0 }}
        transition={{ repeat: Infinity, duration: 3, repeatType: "reverse" }}
        className="absolute bottom-[20px] left-[30px] sm:bottom-[40px] sm:left-[-20px] md:left-[-10px] bg-white rounded-[30px] shadow-lg px-4 md:px-5 py-2 md:py-3 flex items-center gap-2 md:gap-3 z-20"
      >
        <img src={skilledIcon} alt="Skilled Icon" className="w-[24px] md:w-[28px] h-[24px] md:h-[28px]" />
        <div className="text-[#222] text-[13px] sm:text-[14px] md:text-[15px] font-medium leading-tight">
          Skilled <br /> professionals
        </div>
      </motion.div>
    </div>
  </div>
</section>


      
   <section className="bg-[#1E1E1E] text-white py-16 px-6 md:px-12 lg:px-24 font-poppins">
  <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10 lg:gap-0">

    {/* Left Heading */}
    <div className="w-full lg:w-[36%]">
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold leading-tight">
        What we have and what <br />
        we’ve done
      </h2>
    </div>

    {/* Stats Row */}
    <div className="w-full lg:w-[60%] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">

      {/* Stat 1 */}
      <div className="flex items-center gap-4">
        <p className="text-4xl sm:text-5xl font-light leading-none">
          <CountUp end={60} duration={2.5} />+
        </p>
        <div className="text-sm leading-tight">
          <p>Active</p>
          <p>Projects</p>
        </div>
      </div>

      {/* Divider 1 */}
      <div className="hidden sm:block h-[48px] w-px bg-[#5B5B5B]" />

      {/* Stat 2 */}
      <div className="flex items-center gap-4">
        <p className="text-4xl sm:text-5xl font-light leading-none">
          <CountUp end={50} duration={2.5} />+
        </p>
        <div className="text-sm leading-tight">
          <p>Expert</p>
          <p>Teams</p>
        </div>
      </div>

      {/* Divider 2 */}
      <div className="hidden sm:block h-[48px] w-px bg-[#5B5B5B]" />

      {/* Stat 3 */}
      <div className="flex items-center gap-4">
        <p className="text-4xl sm:text-5xl font-light leading-none">
          <CountUp end={250} duration={2.5} />+
        </p>
        <div className="text-sm leading-tight">
          <p>Projects</p>
          <p>Completed</p>
        </div>
      </div>

    </div>
  </div>
</section>



    <section className="bg-[#2F4236] text-white py-20 px-6 font-poppins">
      <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row items-center gap-12">

        {/* Left: Rotating Image */}
        <div className="flex-1 flex justify-center items-center">
          <img
            src={images[currentImage]}
            alt="Business Growth"
            className="w-[480px] h-[480px] object-contain transition-all duration-700"
          />
        </div>

        {/* Right: Text */}
        <div className="flex-1 text-center lg:text-left">
          <p className="bg-[#445D4E] text blod-sm inline-block px-4 py-1 rounded-full mb-4">
            Who are we
          </p>
          <h2 className="text-[40px] leading-[50px] font-bold mb-6">
            Take your business to <br className="hidden md:block" /> the next level
          </h2>
          <p className="text-gray-300 text-base leading-[28px] max-w-[520px] mx-auto lg:mx-0">
            Lentera Technologies has been delivering software solutions since 2015,
            helping small and medium businesses manage customer relationships,
            warranties, and complaints. Our approachable team ensures smooth,
            direct communication with developers.
          </p>
        </div>
      </div>
    </section>

<section className="bg-gray-50 py-20 font-[Poppins]">
  <div className="text-center mb-12 px-4">
    {/* Tag */}
    <span className="text-sm bg-green-100 weight-500 size-16px  text-green-600 rounded-full px-4 py-1">
       Technologies we used   
              </span>
    

    {/* Heading */}
    <h2 className="text-[48px] weight-600 size-48px leading-tight font-semibold mt-6">
      Our Expertise in Cutting-Edge <br />
      Technologies
    </h2>

    {/* Subtext */}
    <p className="text-[#4B5563]font-size-16px weight-400 line-height-24px text-base max-w-2xl mx-auto mt-4 leading-relaxed">
      At Lentera Technologies, we combine innovative technologies and AI-driven solutions to meet your offshor development needs, delivering scalable,
      customized software solutions across multiple platforms.
    </p>
  </div>


      <div className="max-h-[600px] overflow-y-auto px-4 sm:px-6 md:px-20">
  {/* Sticky Tabs */}
  <div className="sticky top-0 z-20 bg-gray-50 py-3 overflow-x-auto">
    <div className="flex justify-start md:justify-center gap-3 sm:gap-4 px-2 min-w-max md:min-w-0">
      {Object.keys(categories).map((category) => (
        <button
          key={category}
          onClick={() => setActiveTab(category)}
          className={`px-3 sm:px-4 py-1 rounded-full font-medium text-xs sm:text-sm whitespace-nowrap transition-all duration-200 ${
            activeTab === category
              ? "bg-green-200 text-green-800"
              : "text-gray-500 hover:text-[#212129]"
          }`}
        >
          {category}
        </button>
      ))}
    </div>
  </div>

        {/* Tech Cards Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 mt-8">
          {categories[activeTab].map((tech) => (
            <div
              key={tech.name}
              className="bg-white rounded-xl  flex flex-col items-center justify-center p-4"
            >
              <img
                src={tech.icon}
                alt={tech.name}
                width={40}
                height={40}
                className="mb-2"
              />
              <p className="text-sm font-medium text-gray-800">{tech.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
    
     
  <section className="bg-[#FFF2C6] py-20 px-4 sm:px-8 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center relative gap-16 md:gap-10">
        {/* LEFT IMAGE & ICONS */}
        <div className="relative w-full max-w-[640px] h-[420px] mx-auto md:mx-0">
          <img
            src={groupedImage}
            alt="Team"
            className="absolute left-0 bottom-0 w-full h-full object-contain"
          />

          {/* Code Icon */}
          <motion.img
            src={codeIcon}
            alt="Code Icon"
            className="absolute left-[38%] top-[8%] w-[48px] sm:w-[60px] h-[48px] sm:h-[60px]"
            animate={{ y: [0, -12, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
          />

          {/* Paint Icon */}
          <motion.img
            src={paintIcon}
            alt="Paint Icon"
            className="absolute left-[70%] bottom-[16%] w-[56px] sm:w-[72px] h-[56px] sm:h-[72px]"
            animate={{ y: [0, -12, 0] }}
            transition={{ duration: 2.2, repeat: Infinity }}
          />

          {/* Developer Badge */}
          <motion.div
            className="absolute left-[20%] bottom-[6%] bg-black text-white text-xs sm:text-sm px-5 sm:px-6 py-2 sm:py-3 rounded-full flex items-center shadow-lg"
            animate={{ y: [0, -8, 0] }}
            transition={{ duration: 2.3, repeat: Infinity }}
          >
            <span className="text-lg sm:text-xl font-bold mr-2">60+</span>
            <span className="font-medium leading-tight">
              Experienced<br className="hidden sm:block" />
              developers
            </span>
          </motion.div>

          {/* Designer Badge */}
          <motion.div
            className="absolute left-[56%] top-[49%] bg-[#00E059] text-black text-xs sm:text-sm px-5 sm:px-6 py-2 sm:py-3 rounded-full flex items-center shadow-md"
            animate={{ y: [0, -8, 0] }}
            transition={{ duration: 2.1, repeat: Infinity }}
          >
            <span className="text-lg sm:text-xl font-bold mr-2">45+</span>
            <span className="font-medium leading-tight">Designers</span>
          </motion.div>
        </div>

        {/* RIGHT TEXT SECTION */}
        <div className="flex-1 text-center md:text-left">
          <div className="inline-block bg-white px-5 py-2 rounded-full text-[#1E1E1E] font-medium text-base mb-6 shadow">
            Hire developers & designers
          </div>
          <h2 className="text-[32px] sm:text-[42px] md:text-[56px] font-semibold text-[#1E1E1E] leading-tight mb-6">
            Hire employees now
          </h2>
          <p className="text-[#1E1E1E] text-base sm:text-[16px] md:text-lg mb-10 max-w-xl mx-auto md:mx-0">
            We assist you to hire dedicated developers & designers who combine their unmatched level of expertise with global processes to maximize your business brand image.
          </p>
         <Link to="https://www.lentera.in/careers/">
  <button className="bg-[#FFC727] hover:bg-[#ffb700] transition text-black font-semibold px-8 py-4 rounded-full text-base flex items-center gap-2 mx-auto md:mx-0 shadow-md">
    HIRE US NOW <span className="text-xl">→</span>
  </button>
</Link>
        </div>
        
      </div>
    </section>
    
  
  <section className="bg-white py-20 px-6 font-poppins">
  <div className="max-w-7xl mx-auto">
    {/* Section Heading */}
    <div className="text-center mb-12">
      <span className="text-sm bg-green-100 text-green-600 rounded-full px-4 py-1">
        Industries we serve
      </span>
      <h2 className="text-4xl font-bold mt-4 leading-tight">
        AI-powered solutions across
        <br className="hidden md:block" /> leading industries
      </h2>
      <p className="text-gray-600 max-w-2xl mx-auto mt-4">
        We deliver industry-specific AI and software innovations to streamline operations and improve ROI across sectors.
      </p>
    </div>

    {/* Cards */}
   
<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
  {industries.map((item, idx) => (
    <div
      key={idx}
      className={`relative rounded-3xl p-6 min-h-[260px] flex flex-col justify-between shadow-sm ${item.bgColor}`}
    >
      <div>
        <h3 className="text-lg font-semibold mb-2">{item.title}</h3>
        <p className="text-gray-700 text-sm leading-relaxed">
          {item.description}
        </p>
      </div>

      {/* Learn More Button */}
      <div className="flex items-center justify-between mt-6">
        <Link
          to={item.link}
          className="text-sm font-semibold border border-black px-5 py-2 rounded-full hover:bg-black hover:text-white transition flex items-center gap-2"
        >
          Learn more <span>→</span>
        </Link>
      </div>

      {/* Icon at exact bottom-right corner */}
      <div className="absolute bottom-0 right-0">
        <img
          src={item.icon}
          alt={item.title}
          className="w-14 h-14 object-contain"
        />
      </div>
    </div>
  ))}
</div>

  </div>
</section>






     
    
    
<section className="font-poppins bg-white py-16 px-4 sm:px-6 flex justify-center">
  <div className="w-full max-w-[1312px] bg-black rounded-[40px] sm:rounded-[60px] flex flex-col lg:flex-row items-center justify-between px-6 sm:px-10 lg:px-16 py-10 relative overflow-hidden">
    
    {/* Left Content */}
    <div className="w-full lg:w-[60%] text-white z-10 mb-10 lg:mb-0">
      {/* Tag */}
      <div className="bg-gradient-to-r from-purple-500 to-blue-500 text-white font-semibold px-4 sm:px-5 py-1.5 rounded-full inline-block text-sm mb-5">
        AI solutions
      </div>

      {/* Heading */}
      <h2 className="text-[26px] sm:text-[32px] md:text-[36px] lg:text-[42px] leading-tight font-extrabold mb-5">
        Innovations in AI improving <br className="hidden sm:block" /> user experience
      </h2>

      {/* Description */}
      <p className="text-gray-300 text-sm sm:text-base mb-8 leading-relaxed max-w-[95%] sm:max-w-[90%]">
        The integration of AI services expands our digital capabilities by utilizing
        advanced artificial intelligence technologies, which enhance automation,
        decision-making, and overall efficiency.
      </p>

      {/* Button */}
      <button className="bg-white text-black font-semibold text-sm sm:text-base px-6 py-3 rounded-full flex items-center gap-2 hover:bg-gray-100 transition">
        KNOW MORE <span className="text-xl">→</span>
      </button>
    </div>

    {/* Right Image */}
    <div className="w-full lg:w-[40%] flex justify-center lg:justify-end z-10">
      <img
        src={aiBot}
        alt="AI Bot"
        className="w-[260px] sm:w-[300px] md:w-[340px] lg:w-[360px] h-auto object-contain"
      />
    </div>

    {/* Gradient Overlay */}
    <div className="absolute inset-0 rounded-[40px] sm:rounded-[60px] bg-gradient-to-br from-transparent via-[#7f00ff40] to-[#7f00ff10] pointer-events-none" />
  </div>
</section>

     <section className="py-20 px-6 bg-white font-poppins overflow-hidden">
      <div className="max-w-7xl mx-auto text-center mb-10">
        <div className="inline-block bg-green-100 text-green-700 text-sm font-semibold px-4 py-1 rounded-full mb-3">
          Our services
        </div>
        <h2 className="text-4xl font-bold text-gray-900 mb-4">
          We offer different services
        </h2>
        <p className="text-gray-600 max-w-2xl mx-auto">
          We offer a comprehensive range of services designed to support and enhance your business operations, with solutions tailored to your specific needs.
        </p>
      </div>

      <div className="relative overflow-hidden w-full" onClick={handleToggleScroll}>
        <motion.div animate={controls} className="flex gap-[28px] w-max cursor-pointer">
          {[...services, ...services].map((service, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-[328px] h-[324px] bg-[#F8F8F8] rounded-[24px] border border-gray-200 shadow-md overflow-hidden"
            >
              <div className="h-[160px] w-full">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-5 h-[164px] flex flex-col justify-between">
                <div>
                  <h3 className="text-[18px] font-semibold text-gray-900 leading-tight mb-1">
                    {service.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-snug">
                    {service.description}
                  </p>
                </div>
                <Link
                  to={service.link}
                  onClick={(e) => e.stopPropagation()} // Prevents click bubbling
                  className="mt-3 flex items-center justify-between text-green-600 font-medium text-sm bg-[white] rounded-full px-4 py-2 w-[] hover:bg-green-50 transition"
                >
                  Learn more <span className="text-lg ml-22">→</span>
                </Link>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
 

 
    
    
   
     
    {/* <section
      className="py-16 font-poppins"
      style={{
        backgroundColor: '#f8f9fb',
        backgroundImage: `url(${gridBg.src})`,
        backgroundRepeat: 'repeat',
        backgroundSize: 'contain',
      }}
    ></section> */}
 

   <section className="w-full flex justify-center bg-white py-16 px-4 sm:px-6 font-poppins">
  <div
    className="w-full max-w-[1312px] bg-white rounded-[60px] px-4 sm:px-10 lg:px-16 py-10 sm:py-16 flex flex-col lg:flex-row items-center justify-between overflow-hidden"
    style={{
      boxShadow:
        "0px 25px 80px rgba(95, 245, 126, 0.3), 0px 25px 80px rgba(255, 116, 98, 0.3), 0px 25px 80px rgba(186, 132, 255, 0.3), 0px 25px 80px rgba(255, 220, 0, 0.3)",
    }}
  >
    {/* Left Side Image */}
    <div className="relative w-full lg:w-[45%] flex justify-center items-center mb-10 lg:mb-0">
      <div className="absolute -top-6 -left-6 w-[90%] h-full rounded-[100px] bg-[#e8deff] -z-10" />
      <img
        src={personImage}
        alt="Consultants"
        className="relative z-10 w-full max-w-[360px] sm:max-w-[400px] object-contain"
      />
    </div>

    {/* Right Side Content */}
    <div className="w-full lg:w-[55%] flex flex-col items-start px-1 sm:px-4">
      {/* Top Badge */}
      <div className="inline-block bg-[#ddffe9] text-[#1bae55] text-sm px-6 py-2 rounded-full font-medium mb-4">
        Any time & any where consulting
      </div>

      {/* Heading */}
      <h2 className="text-[28px] sm:text-[36px] md:text-[42px] font-semibold text-[#171717] leading-tight mb-4">
        Get a free consultancy
      </h2>

      {/* Description */}
      <p className="text-[#4a4a4a] text-base leading-relaxed mb-6 max-w-[500px]">
        We help you to see world differently, discover opportunities you may never have imagined.
      </p>

      {/* Contact Details Block */}
      <div className="w-full flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6 sm:gap-0 mb-8">

        {/* Phone */}
        <div className="flex items-center gap-4 w-full sm:w-auto">
          <span className="bg-[#f3fff7] p-4 rounded-full">
            <img src={phoneIcon} alt="Phone" className="w-6 h-6 sm:w-8 sm:h-8" />
          </span>
          <div>
            <p className="text-sm text-[#6b6b6b] mb-1">Phone number</p>
            <p className="text-lg font-bold text-[#171717] whitespace-nowrap">+91-44-4856–3345</p>
          </div>
        </div>

        {/* Divider */}
        <div className="hidden sm:block h-10 w-px bg-[#ddd]" />

        {/* Email */}
        <div className="flex items-center gap-4 w-full sm:w-auto">
          <span className="bg-[#f3fff7] p-4 rounded-full">
            <img src={mailIcon} alt="Mail" className="w-6 h-6 sm:w-8 sm:h-8" />
          </span>
          <div>
            <p className="text-sm text-[#6b6b6b] mb-1">Email address</p>
            <p className="text-lg font-bold text-[#171717] whitespace-nowrap">info@lenteratech.com</p>
          </div>
        </div>

      </div>

      {/* CTA Button */}
      <Link to="/contact">
        <button className="bg-[#009c3c] hover:bg-[#007b2e] text-white font-bold text-base px-8 py-4 rounded-full flex items-center gap-3 transition-all">
          CONNECT WITH US
          <img src={arrowRight} alt="Arrow" className="w-4 h-4" />
        </button>
      </Link>
    </div>
  </div>
</section>


  
    <div className="bg-[#111215] text-white">
   {/* Footer Section */}
   <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
     {/* Newsletter Section */}
     <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
            {/* Top newsletter */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
              {/* Left Side */}
              <div className="flex items-start md:items-center gap-4 md:gap-6">
                <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
                <h2 className="text-xl md:text-[28px] font-bold leading-tight">
                  Join our newsletter to <br className="hidden md:block" />
                  keep up to date with us!
                </h2>
              </div>

              <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
                {/* Newsletter input */}
                <div
                  className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
                  style={{ borderRadius: "6px" }}
                >
                  <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
                  <input
                    type="email"
                    value={submail}
                    onChange={(e) => setSubmail(e.target.value)}
                    placeholder="Enter your email"
                    className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
                  />
                </div>


                {/* Captcha line (canvas + refresh + input + subscribe button) */}
                {/* Outer wrapper to center the row */}
                <div className="w-full flex justify-center">
                  <div className="flex items-center gap-3">
                    {/* Captcha canvas */}
                    <div className="captcha-box">
                      <canvas
                        ref={newsletterCanvasRef}
                        id="newsletterCaptchaCanvas"
                        width={60}
                        height={40}
                        style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
                      />
                    </div>

                    {/* Refresh button */}
                    <button
                      onClick={handleReload}
                      style={{
                        background: "#07862B ",
                        color: "#fff",
                        border: "none",
                        padding: "6px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="23 4 23 10 17 10"></polyline>
                        <polyline points="1 20 1 14 7 14"></polyline>
                        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                      </svg>
                    </button>

                    {/* Captcha input */}
                    <input
                      type="text"
                      placeholder="Enter captcha"
                      value={newsletterUserCaptcha}
                      onChange={(e) => setNewsletterUserCaptcha(e.target.value)}
                      className="captcha-input"
                    />

                    {/* Subscribe button */}
                    <button className="subscribe-button" onClick={handleSubscribe}>
                      Subscribe
                    </button>
                  </div>
                </div>

                <style>{`
  .captcha-box {
    width: 60px !important;
    height: 35px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    color :131519;
    background-color: #fff !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
 
  .captcha-input {
    padding: 11px 8px !important;
    border-radius: 6px !important;
    border: 1px solid #ccc !important;
    outline: none !important;
    width: 100px !important;
    background: #131519 !important;
    color: #fff !important;
    font-size: 10px !important;
  }
 
  .subscribe-button {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    background: #07862B !important;
    color: #fff !important;
    font-weight: bold !important;
    font-size: 13px !important;
    cursor: pointer !important;
    white-space: nowrap !important;
  }
 
  @media(max-width:480px){
    .captcha-input { width: 70px !important; font-size: 12px !important; }
    .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
  }
`}</style>

              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-700 w-full" />

            {/* Main Footer Content */}
            <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
              {/* Company Info */}
              <div className="w-full lg:w-[30%]">
                <a href="/" aria-label="Lentera Home">
                  <img src={nlen} alt="Lentera logo" className="mb-6" />
                </a>
                <p className="text-[#d4d4d4] leading-relaxed">
                  We are highly experienced in offering software development, mobile
                  application development, software consulting and project management
                  delivery.
                </p>
                {/* Social Icons */}
                <div className="flex gap-4 mt-6 flex-wrap">
                  <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
                    <img src={inst} alt="Instagram" className="w-8 h-8" />
                  </a>
                  <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
                    <img src={face} alt="Facebook" className="w-8 h-8" />
                  </a>
                  <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={you} alt="YouTube" className="w-8 h-8" />
                  </a>
                  <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={lin} alt="LinkedIn" className="w-8 h-8" />
                  </a>
                  <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
                    <img src={twi} alt="X" className="w-8 h-8" />
                  </a>
                </div>

              </div>

              {/* Services */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
                  <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
                  <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
                  <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
                  <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
                  <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
                  <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
                </ul>
              </div>


              {/* Insights */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="https://blog.lentera.in/" className="hover:text-white">Blog</a></li>
                  <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
                  <li><a href="https://blog.lentera.in/" className="hover:text-white">News</a></li>
                </ul>
              </div>

              {/* Contact */}
              <div className="w-full md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
                <div className="flex items-start gap-3 mb-3">
                  <img src={phonee} alt="phone" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Phone number</p>
                    <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
                      +91-44-4856-3345
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 mb-3">
                  <img src={mail} alt="email" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Email address</p>
                    <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
                      info@lenteratech.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <img src={loc} alt="location" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Location</p>
                    <a
                      href="https://www.google.com/maps?q=G1,+Plot+No+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-medium text-sm hover:underline block"
                    >
                      G1, Plot No, 824 and 826, 3rd<br />
                      Main Rd, Ram Nagar South,<br />
                      Madipakkam, Chennai,<br />
                      Tamil Nadu 600091
                    </a>
                  </div>
                </div>


              </div>
            </div>
          </div>
   </footer>
 
   {/* Bottom Section */}
   <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
     <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
     <div className="flex flex-wrap gap-4 justify-center md:justify-end">
       <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
       <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
       <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
       <a href="/copyright-information/" className="hover:underline">Copyright information</a>
     </div>
   </div>
 </div>
 
 
      </>
      
  );
};

export default HeroSection;
